import * as React from 'react';

export interface ImageProps {
    source: string;
    alt?: string;
    className?: string;
}

export function Image (props: ImageProps) {
    const imgSource = require('../../content/img/' + props.source);
    return (
      <img className={props.className} src={imgSource} alt={props.alt} />
    );
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/uiComponents/layout/Image.tsx